export function authHeader() {
    // return authorization header with jwt token
    let jwtToken = localStorage.getItem('auth-token');

    if( jwtToken) {
        return { 'Authorization': 'Bearer ' + jwtToken }
    }
}
